export default "__VITE_ASSET__DGAsLXTy__"